(() => {
  if (window.fellauraCollectionSwatchesBound) return;
  window.fellauraCollectionSwatchesBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.fellaura-color-swatch[data-fellaura-image]');
    if (!button) return;
    const card = button.closest('.product-card');
    const image = card && card.querySelector('.product-card__image .first-image');
    if (!image) return;
    event.preventDefault();
    const url = button.dataset.fellauraImage;
    const loader = new Image();
    card.dataset.fellauraPendingImage = url;
    loader.onload = () => {
      if (card.dataset.fellauraPendingImage !== url) return;
      image.classList.remove('lazyload', 'lazyloading');
      image.classList.add('lazyloaded');
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-widths');
      image.setAttribute('data-src', url);
      image.src = url;
      image.alt = button.dataset.fellauraAlt;
      card.classList.add('fellaura-color-selected');
      card.querySelectorAll('.fellaura-color-swatch[aria-pressed]').forEach((swatch) => {
        swatch.setAttribute('aria-pressed', String(swatch === button));
      });
    };
    loader.src = url;
  });
})();
